import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_7 = { class: "col-lg-12 col-md-12 mb-4 d-flex align-items-center" }
const _hoisted_8 = { class: "form-check form-switch mt-4" }
const _hoisted_9 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_10 = { class: "d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_11 = {
  key: 0,
  class: "border rounded p-2 bg-light d-flex align-items-center justify-content-center",
  style: {"width":"150px","height":"100px"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "flex-grow-1" }
const _hoisted_14 = ["required"]
const _hoisted_15 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Partner' : 'Add Partner',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Partner Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                placeholder: "Enter partner / university name",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "MoU Link (Optional)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "url",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.mou_link) = $event)),
                placeholder: "https://example.com/mou.pdf"
              }, null, 512), [
                [_vModelText, _ctx.form.mou_link]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isActive",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.is_active) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.is_active]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "isActive"
                }, "Active Status (Visible to users)", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Partner Logo File", -1)),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.previewUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("img", {
                        src: _ctx.previewUrl,
                        alt: "logo preview",
                        style: {"max-width":"100%","max-height":"100%","object-fit":"contain"}
                      }, null, 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("input", {
                    type: "file",
                    ref: "fileInput",
                    class: "form-control",
                    accept: "image/*",
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                    required: !_ctx.isEditing
                  }, null, 40, _hoisted_14),
                  _cache[8] || (_cache[8] = _createElementVNode("small", { class: "text-muted d-block mt-1" }, "Recommended size: landscape aspect ratio, transparent PNG or clean SVG. Max size: 2MB.", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_RouterLink, {
              to: "/partners",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Partner' : 'Create Partner'), 1)
            ], 8, _hoisted_16)
          ])
        ], 32)
      ])
    ])
  ]))
}